// removed by extract-text-webpack-plugin
module.exports = {"product-detail-collapse":"product-detail-collapse","collapse-content":"collapse-content","open":"open","fix-content":"fix-content","title-collapse":"title-collapse"};


//////////////////
// WEBPACK FOOTER
// ./components/product-detail/sub-view/product-detail/style.scss
// module id = ./components/product-detail/sub-view/product-detail/style.scss
// module chunks = 0